import { useState, useEffect } from 'react';

// Reads the global speed-unit preference from localStorage (default 'mph').
// Listens for the 'storage' event so cards react if the unit is toggled
// in another tab (e.g. the cockpit MPH/KM/H toggle on RigDetail).
export function useSpeedUnit() {
  const [unit, setUnit] = useState(() => {
    try { return localStorage.getItem('mr_speed_unit') || 'mph'; } catch { return 'mph'; }
  });

  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'mr_speed_unit') setUnit(e.newValue || 'mph');
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return unit; // 'mph' | 'kmh'
}

export function formatSpeed(speedKph, unit) {
  if (speedKph == null) return '–';
  return unit === 'mph' ? Math.round(speedKph * 0.621371) : Math.round(speedKph);
}

export function speedUnitLabel(unit) {
  return unit === 'mph' ? 'mph' : 'km/h';
}